<template src="./Add.html"></template>

<script>
import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getLookups")
    this.$store.dispatch("lookups/getVacationsTypes");
  },
  computed: {
    vacationsTypes() {
      return this.$store.state.lookups.vacationsTypes;
    },
    administrationTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.AdministrationTypes
      );
    },
    administrations() {
      return [...this.$store.state.lookups.administrations];
    },
    departments() {
      return this.$store.state.lookups.departments;
    },
    units() {
      return this.$store.state.lookups.units;
    },
    assignmentTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.AssignmentTypes
      );
    },
  },
  data() {
    return {
      employees: [],
      filter: {
        administrationTypeId: null,
        administrationId: null,
        departmentId: null,
        unitId: null,
      },
      newEmployee: {
        employmentNo: null,
        employeeId: 0,
        fullName: null,
        balance: null,
      },
      leave: {
        description: null,
          employeeId: null,
          startDate: null,
          endDate: null,
          officialHoliday: null,
          hasOffical: false,
      },
      hasResult: false,
      showBtn: true,
    };
  },
  methods: {
    getEmployees() {
      this.employees = [];
      this.$store.dispatch("lookups/getEmployees", this.filter).then((res) => {
        this.employees = res;
      });
    },
    changeType() {
      this.filter.administrationId = null;
      this.filter.departmentId = null;
      this.filter.unitId = null;
      this.leave.employeeId = null;
      this.reset();

      this.$store.dispatch(
        "lookups/getAdministrationsByType",
        this.filter.administrationTypeId
      );
      // this.getEmployees();
    },
    changeAdministration() {
      this.filter.departmentId = null;
      this.filter.unitId = null;
      this.reset();
      if (this.filter.administrationTypeId != 1002) {
        this.$store.dispatch(
          "lookups/getDepartments",
          this.filter.administrationId
        );
      } else {
        this.$store.dispatch("lookups/getUnitsById", {
          typeId: 1,
          id: this.filter.administrationId,
        });
      }
      this.getEmployees();
    },
    changeDepartment() {
      this.reset();
      this.filter.unitId = null;
      this.$store.dispatch("lookups/getUnitsById", {
        typeId: 2,
        id: this.filter.departmentId,
      });
      this.getEmployees();
    },

    setEmp() {
      this.reset();
      this.hasResult = true;
    },
    changeUnit() {
      this.reset();
      this.getEmployees();
    },
    reset() {

      this.leave.vacationTypeId = null;
      this.newEmployee.balance = null;
      //this.leave.startDate = null;
      //this.leave.endDate = null;
      this.leave.description = null;
      this.leave.attachmentName = null;
      this.leave.file = null;
    },

    checkDate() {
      if (this.leave.startDate > this.leave.endDate) {
        showAlert("يجب ان يكون تاريخ بداية الاجازة اقل من تاريخ نهايتها");
        this.leave.endDate = null;
        return;
      }
    },
    getVacationsBalance() {
      this.showBtn = true;

      if (this.leave.vacationTypeId == 1) {
        let params = {
          type: this.leave.vacationTypeId,
          id: this.leave.employeeId,
        };
        this.$store
          .dispatch("employeeLeaves/getVacationsBalance", params)
          .then((res) => {
            console.log(res);
            if(res == undefined){
                this.showBtn = false;
            }
            this.newEmployee.balance = res.balance.duration;
            this.leave.employeeVacationBalanceId =
              res.balance.employeeVacationBalanceId;
          })
          .catch(() => {});
      }
    },
    
    getDuration() {
      if (this.leave.startDate != null && this.leave.endDate != null) {
        if (this.leave.startDate > this.leave.endDate) {
          this.leave.duration = null;
          this.leave.endDate = null;
          showAlert(`يجب ان يكون تاريخ بداية الاجازة قبل نهايتها`);
        } else {
          const s = new Date(this.leave.startDate);
          const d = new Date(this.leave.endDate);

          //const diffTime = Math.abs(d - fromDate);

          this.leave.duration = this.calcBusinessDays(s, d);
        }
      }
    },
    calcBusinessDays(dDate1, dDate2) {
      // input given as Date objects
      var iWeeks,
        iDateDiff,
        iAdjust = 0;
      if (dDate2 < dDate1) return -1; // error code if dates transposed
      var iWeekday1 = dDate1.getDay(); // day of week
      var iWeekday2 = dDate2.getDay();
      iWeekday1 = iWeekday1 == 6 ? 7 : iWeekday1; // change Sunday from 0 to 7
      iWeekday2 = iWeekday2 == 6 ? 7 : iWeekday2;
      if (iWeekday1 == 5 && iWeekday2 == 5) iAdjust = 1; // adjustment if both days on weekend
      iWeekday1 = iWeekday1 == 5 ? 5 : iWeekday1; // only count weekdays
      iWeekday2 = iWeekday2 == 5 ? 5 : iWeekday2;

      // calculate differnece in weeks (1000mS * 60sec * 60min * 24hrs * 7 days = 604800000)
      iWeeks = Math.floor((dDate2.getTime() - dDate1.getTime()) / 604800000);

      if (iWeekday1 <= iWeekday2) {
        iDateDiff = iWeeks * 5 + (iWeekday2 - iWeekday1);
      } else {
        iDateDiff = (iWeeks + 1) * 5 - (iWeekday1 - iWeekday2);
      }

      iDateDiff -= iAdjust; // take into account both days on weekend

      return iDateDiff + 1; // add 1 because dates are inclusive
    },
    confirm() {
      this.$store
        .dispatch("employeeLeaves/add", this.leave)
        .then(() => {
          this.back();
        })
        .catch(() => {});
    },

    back() {
      this.$emit("back");
    },
  },
};
</script>